var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHouseSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "house 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M23.9312 11.3423L15.1812 3.3907C14.8586 3.09556 14.4372 2.93188 14 2.93188C13.5627 2.93188 13.1413 3.09556 12.8187 3.3907L4.06874 11.3423C3.88959 11.5062 3.7465 11.7055 3.64859 11.9278C3.55068 12.1499 3.50007 12.3901 3.49999 12.6329V22.7064C3.49288 23.1475 3.64864 23.5759 3.93749 23.9095C4.10143 24.0959 4.30339 24.2451 4.52978 24.3469C4.75617 24.4488 5.00174 24.501 5.24999 24.5001H10.5C10.732 24.5001 10.9546 24.4079 11.1187 24.2438C11.2828 24.0797 11.375 23.8572 11.375 23.6251V18.3751C11.375 18.143 11.4672 17.9205 11.6313 17.7563C11.7954 17.5923 12.0179 17.5001 12.25 17.5001H15.75C15.982 17.5001 16.2046 17.5923 16.3687 17.7563C16.5328 17.9205 16.625 18.143 16.625 18.3751V23.6251C16.625 23.8572 16.7172 24.0797 16.8813 24.2438C17.0454 24.4079 17.2679 24.5001 17.5 24.5001H22.75C23.0402 24.5027 23.3263 24.4311 23.5812 24.2923C23.8586 24.1412 24.0902 23.9183 24.2519 23.647C24.4135 23.3757 24.4992 23.0659 24.5 22.7501V12.6329C24.4999 12.3901 24.4493 12.1499 24.3514 11.9278C24.2535 11.7055 24.1104 11.5062 23.9312 11.3423Z",
    fill: "#17B986"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouseSvg);
export default __webpack_public_path__ + "static/media/HouseSvg.aaeed55eb81d17f84feab49fb791ce3a.svg";
export { ForwardRef as ReactComponent };